export const EMPTY_ADDITIONAL_FIELDS: [] = [];
export const EMPTY_JSON_SECTIONS: [] = [];
